import { render } from "./ImageControls.vue?vue&type=template&id=24a92d2d"
import script from "./ImageControls.vue?vue&type=script&lang=js"
export * from "./ImageControls.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__